import { __decorate, __metadata } from "tslib";
import { plainToClass } from "class-transformer";
import { Action, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from "..";
import service from "../../services/api.service";
import { getTenantId } from "@/store/helper";
import { ClockWorkAnalyticsModel } from "../models/clockWorkAnalytics/clockWorkAnalytics";
import { ClockWorkAnalyticsRequestModel } from "../models/clockWorkAnalytics/clockWorkAnalyticsRequest";
import { GuidItemModel } from "../models/shared/guidItem";
let ClockWorkAnalyticModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e;
    let ClockWorkAnalyticModule = class ClockWorkAnalyticModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "clockWorkAnalytics";
            this.clockWorkAnalytics = [];
            this.defaults = [];
            this.excelBlob = null;
        }
        async GetTeams() {
            var url = `${getTenantId()}/${this.apiNode}/defaults`;
            let { data } = await service.get(url);
            if (data) {
                this.SetTeams(plainToClass(GuidItemModel, data.defaults));
                return data;
            }
        }
        async GetClockWorkAnalytics(clockWorkAnalyticsRequest) {
            var url = `${getTenantId()}/${this.apiNode}/`;
            let { data } = await service.post(url, clockWorkAnalyticsRequest);
            if (data) {
                this.SetClockWorkAnalytics(plainToClass(ClockWorkAnalyticsModel, data.clockWorkAnalytics));
                return data;
            }
        }
        async GetClockWorkAnalyticsAsReport(clockWorkAnalyticsRequest) {
            var url = `${getTenantId()}/${this.apiNode}/excel`;
            let { data } = await service.post(url, clockWorkAnalyticsRequest, { responseType: "blob" });
            if (data) {
                this.setBlobData(data);
            }
            return data;
        }
        async SetTeams(defaults) {
            this.defaults = defaults;
        }
        async SetClockWorkAnalytics(clockWorkAnalytics) {
            this.clockWorkAnalytics = clockWorkAnalytics;
        }
        async setBlobData(data) {
            this.excelBlob = data;
        }
        ClearClockWorkAnalytics() {
            this.clockWorkAnalytics = [];
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], ClockWorkAnalyticModule.prototype, "GetTeams", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof ClockWorkAnalyticsRequestModel !== "undefined" && ClockWorkAnalyticsRequestModel) === "function" ? _b : Object]),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], ClockWorkAnalyticModule.prototype, "GetClockWorkAnalytics", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof ClockWorkAnalyticsRequestModel !== "undefined" && ClockWorkAnalyticsRequestModel) === "function" ? _d : Object]),
        __metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
    ], ClockWorkAnalyticModule.prototype, "GetClockWorkAnalyticsAsReport", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], ClockWorkAnalyticModule.prototype, "SetTeams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], ClockWorkAnalyticModule.prototype, "SetClockWorkAnalytics", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], ClockWorkAnalyticModule.prototype, "setBlobData", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ClockWorkAnalyticModule.prototype, "ClearClockWorkAnalytics", null);
    ClockWorkAnalyticModule = __decorate([
        Module({ dynamic: true, store: store, name: "clockWorkAnalytics", namespaced: true })
    ], ClockWorkAnalyticModule);
    return ClockWorkAnalyticModule;
})();
export const ClockWorkAnalyticsModule = getModule(ClockWorkAnalyticModule);
